<template>
  <div class="gb-page guides-page">
    <HeadNav selectedLanguage="en" page="guides" />
    <BreadcrumbNav :items="[{ label: 'Guides' }]" />

    <main>
      <section class="guides-hero">
        <div class="page-shell">
          <h1>GB WhatsApp Guides & Tutorials</h1>
          <p>
            Explore GB WhatsApp guides and tutorials, including installation,
            privacy settings, feature tips, updates, backups, and troubleshooting.
          </p>
        </div>
      </section>

      <section class="content-section">
        <div class="page-shell">
          <div class="guides-grid">
            <router-link
              v-for="post in posts"
              :key="post.url"
              class="guide-card"
              :to="post.url"
            >
              <img :src="post.poster" :alt="post.title" />
              <div class="guide-copy">
                <span>{{ post.date }}</span>
                <h2>{{ post.title }}</h2>
                <p>{{ post.desc }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import BreadcrumbNav from '@/components/BreadcrumbNav.vue'
import doc from '@/documents/blogs.js'
import '@/css/base.scss'

export default {
  name: 'GuidesPage',
  components: {
    HeadNav,
    BreadcrumbNav,
  },
  computed: {
    posts() {
      return doc.bloglist.en
        .slice()
        .sort((a, b) => new Date(b.date) - new Date(a.date))
    },
  },
}
</script>

<style lang="scss" scoped>
.guides-page {
  background: #ffffff;
  color: #111111;
  font-family: 'Lora', Georgia, serif;
  font-size: 16px;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
}

.page-shell {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
}

.guides-hero {
  padding: 52px 0 58px;
  background:
    radial-gradient(circle at 16% 20%, rgba(22, 163, 74, 0.12), transparent 34%),
    linear-gradient(180deg, #eefaf2 0%, #ffffff 82%);
  border-bottom: 1px solid #dce9e2;
  text-align: center;

  p:last-child {
    max-width: 760px;
    margin: 16px auto 0;
    color: #33443b;
    font-size: 18px;
  }
}

h1,
h2 {
  margin: 0;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-weight: 400;
  letter-spacing: 0;
}

h1 {
  font-size: clamp(34px, 4vw, 48px);
  line-height: 1.18;
}

h2 {
  font-size: 23px;
  line-height: 1.25;
}

.content-section {
  padding: 56px 0 72px;
}

.content-section .page-shell {
  width: min(1600px, calc(100% - 200px));
}

.guides-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 44px;
}

.guide-card {
  display: flex;
  flex-direction: column;
  min-height: 560px;
  padding: 0;
  border: 1px solid #d7e8de;
  border-radius: 8px;
  background: #ffffff;
  color: #111111;
  text-decoration: none;
  overflow: hidden;
  box-shadow: 0 12px 26px rgba(16, 37, 28, 0.06);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.guide-card:hover {
  transform: translateY(-3px);
  border-color: #98d0b2;
  box-shadow: 0 18px 32px rgba(16, 37, 28, 0.09);
}

.guide-card img {
  width: 100%;
  height: 243px;
  aspect-ratio: 16 / 9;
  display: block;
  object-fit: cover;
  object-position: center;
  background: #f6faf8;
}

.guide-copy {
  padding: 22px 30px 28px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
}

.guide-copy span {
  margin-bottom: 10px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 13px;
  text-transform: uppercase;
}

.guide-copy p {
  margin: 12px 0 0;
  color: #33443b;
}

@media (max-width: 980px) {
  .content-section .page-shell {
    width: min(1120px, calc(100% - 32px));
  }

  .guides-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 28px;
  }
}

@media (max-width: 640px) {
  .guides-hero {
    padding: 40px 0 46px;
  }

  .guides-hero p:last-child {
    font-size: 16px;
  }

  .guide-card {
    min-height: 0;
  }

  .guide-copy {
    padding: 20px 18px 22px;
  }

  .guide-card img {
    height: auto;
    aspect-ratio: 16 / 9;
  }
}
</style>
